var exports = {
  "kL": "DMFriendsView.module__container___RW8xTE",
  "Em": "DMFriendsView.module__mainColumn___RW8xTE",
  "Qs": "DMFriendsView.module__content___RW8xTE",
  "sf": "DMFriendsView.module__searchWrapper___RW8xTE",
  "qc": "DMFriendsView.module__searchIcon___RW8xTE",
  "MJ": "DMFriendsView.module__tabBody___RW8xTE",
  "VW": "DMFriendsView.module__headerContent___RW8xTE",
  "cP": "DMFriendsView.module__titleSection___RW8xTE",
  "gr": "DMFriendsView.module__titleIcon___RW8xTE",
  "Qw": "DMFriendsView.module__titleText___RW8xTE",
  "yF": "DMFriendsView.module__divider___RW8xTE",
  "me": "DMFriendsView.module__tabsWrapper___RW8xTE",
  "xd": "DMFriendsView.module__tabsScroller___RW8xTE",
  "VD": "DMFriendsView.module__tabsInner___RW8xTE",
  "eg": "DMFriendsView.module__tabButton___RW8xTE",
  "vu": "DMFriendsView.module__active___RW8xTE",
  "zB": "DMFriendsView.module__primary___RW8xTE",
  "Lj": "DMFriendsView.module__tabContent___RW8xTE",
};

module.exports = exports;
